/**
 * Pantalla de **Horario láser** (`/horario-laser`). Reemplaza el `PlaceholderPage` de
 * `ROUTES.laserSchedule`. Equivale a `laser_schedule.html` del SSR (demolido en esta
 * feature).
 *
 * Exige `laser_schedule` (mismo permiso que el SSR y la página) vía la vista
 * compartida `ScheduleView`, en modo láser (rejilla de solo órdenes láser). La
 * VISIBILIDAD de la entrada del menú depende además de `sede_laser_activo` (lo
 * gobierna `navConfig.ts`, que lo lee de `/auth/me`); aquí solo se sirve la pantalla.
 */
import { LASER_SCHEDULE_PERMISSION } from "../constants";
import { ScheduleView } from "./ScheduleView";

export function LaserScheduleScreen() {
  return (
    <ScheduleView
      title="Horario láser"
      permission={LASER_SCHEDULE_PERMISSION}
      laser={true}
    />
  );
}
